/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgSparkleShimmer = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M13.535 16.852a.806.806 0 0 0 1.226-.398l.248-.762a1.09 1.09 0 0 1 .26-.42c.118-.12.262-.208.42-.26l.772-.252a.8.8 0 0 0-.023-1.52l-.764-.25a1.074 1.074 0 0 1-.68-.678l-.252-.773a.801.801 0 0 0-1.518.01l-.247.762a1.068 1.068 0 0 1-.665.679l-.773.252a.8.8 0 0 0 .008 1.518l.763.247c.16.054.304.143.422.261.119.118.207.263.258.422l.253.774a.8.8 0 0 0 .292.388Z",
        fill: "url(#SparkleShimmer_svg__a)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.535 16.852a.806.806 0 0 0 1.226-.398l.248-.762a1.09 1.09 0 0 1 .26-.42c.118-.12.262-.208.42-.26l.772-.252a.8.8 0 0 0-.023-1.52l-.764-.25a1.074 1.074 0 0 1-.68-.678l-.252-.773a.801.801 0 0 0-1.518.01l-.247.762a1.068 1.068 0 0 1-.665.679l-.773.252a.8.8 0 0 0 .008 1.518l.763.247c.16.054.304.143.422.261.119.118.207.263.258.422l.253.774a.8.8 0 0 0 .292.388Z",
        fill: "url(#SparkleShimmer_svg__b)",
        fillOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M13.535 16.852a.806.806 0 0 0 1.226-.398l.248-.762a1.09 1.09 0 0 1 .26-.42c.118-.12.262-.208.42-.26l.772-.252a.8.8 0 0 0-.023-1.52l-.764-.25a1.074 1.074 0 0 1-.68-.678l-.252-.773a.801.801 0 0 0-1.518.01l-.247.762a1.068 1.068 0 0 1-.665.679l-.773.252a.8.8 0 0 0 .008 1.518l.763.247c.16.054.304.143.422.261.119.118.207.263.258.422l.253.774a.8.8 0 0 0 .292.388Z",
        fill: "url(#SparkleShimmer_svg__c)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.398 12.807a1.042 1.042 0 0 0 1.204-.003c.178-.13.313-.31.387-.518l.447-1.373a2.337 2.337 0 0 1 1.477-1.479l1.391-.45a1.045 1.045 0 0 0-.044-1.98l-1.375-.448a2.335 2.335 0 0 1-1.48-1.477l-.452-1.388a1.044 1.044 0 0 0-1.973.017l-.457 1.4a2.336 2.336 0 0 1-1.44 1.45l-1.39.447a1.045 1.045 0 0 0 .016 1.974l1.374.445a2.333 2.333 0 0 1 1.481 1.488l.452 1.391c.072.204.206.38.382.504Z",
        fill: "url(#SparkleShimmer_svg__d)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.398 12.807a1.042 1.042 0 0 0 1.204-.003c.178-.13.313-.31.387-.518l.447-1.373a2.337 2.337 0 0 1 1.477-1.479l1.391-.45a1.045 1.045 0 0 0-.044-1.98l-1.375-.448a2.335 2.335 0 0 1-1.48-1.477l-.452-1.388a1.044 1.044 0 0 0-1.973.017l-.457 1.4a2.336 2.336 0 0 1-1.44 1.45l-1.39.447a1.045 1.045 0 0 0 .016 1.974l1.374.445a2.333 2.333 0 0 1 1.481 1.488l.452 1.391c.072.204.206.38.382.504Z",
        fill: "url(#SparkleShimmer_svg__e)",
        fillOpacity: 0.5
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.398 12.807a1.042 1.042 0 0 0 1.204-.003c.178-.13.313-.31.387-.518l.447-1.373a2.337 2.337 0 0 1 1.477-1.479l1.391-.45a1.045 1.045 0 0 0-.044-1.98l-1.375-.448a2.335 2.335 0 0 1-1.48-1.477l-.452-1.388a1.044 1.044 0 0 0-1.973.017l-.457 1.4a2.336 2.336 0 0 1-1.44 1.45l-1.39.447a1.045 1.045 0 0 0 .016 1.974l1.374.445a2.333 2.333 0 0 1 1.481 1.488l.452 1.391c.072.204.206.38.382.504Z",
        fill: "url(#SparkleShimmer_svg__f)"
    }), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("radialGradient", {
        id: "SparkleShimmer_svg__b",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(1.33436 -1.33339 2.02 2.02147 11.663 16.5)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#5178C9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#3E74C7",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "SparkleShimmer_svg__c",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(4.33665 4.66686 -8.01634 7.44914 11.496 11.5)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#C69FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.299,
        stopColor: "#C096FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "SparkleShimmer_svg__e",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "matrix(2.89399 -2.76243 4.1849 4.38421 3.395 12.208)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.333,
        stopColor: "#5178C9"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#3E74C7",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "SparkleShimmer_svg__f",
        cx: 0,
        cy: 0,
        r: 1,
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "rotate(45 -3.172 7.975) scale(8.92954 15.3377)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: 0.2,
        stopColor: "#C69FFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.299,
        stopColor: "#C096FF",
        stopOpacity: 0
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "SparkleShimmer_svg__a",
        x1: 12.664,
        y1: 12.167,
        x2: 17.164,
        y2: 17.337,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#BA6DF1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.492,
        stopColor: "#7376E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#4B9DF5"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "SparkleShimmer_svg__d",
        x1: 4.973,
        y1: 4.71,
        x2: 12.34,
        y2: 12.34,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#C67EFF"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 0.737,
        stopColor: "#7376E1"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#0F6CBD"
    }))));
export default SvgSparkleShimmer;
